import { useEffect, useMemo } from "react";
import DashboardButtonGroup from "../Buttons/dashboard-button-group.jsx";
import "./dashboard-header.scss";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../redux/user/user-selector.js";
import { FluentDropdown } from "../../../../components/FluentUI/Fluent-Dropdown.jsx";
import { FluentDropdownOptionAsObject } from "../../../../components/FluentUI/Fluent-Dropdown-Option-As-Object.jsx";
import PropTypes from "prop-types";
import { formatDateWithDay } from "../../../../util/time-helpers.js";
export const greetings = [
  "Hello",
  "Hi",
  "Hey",
  "Hey there",
  "Welcome back",
  "G’day",
  "Onward",
  "Looking sharp",
  "All set",
  "You’re back",
  "Let’s go",
  "Let’s roll",
  "Bonjour",
  "Howdy",
];

const DashboardHeader = ({
  departments,
  currDepartment,
  setCurrDepartment,
  fetchDepartmentData,
  subDepartments,
  setSubCurrDepartment,
  currSubDepartment,
  refreshLoading
}) => {
  const user = useSelector(selectUser);

  const randomGreeting = useMemo(() => {
    const idx = Math.floor(Math.random() * greetings.length);
    return greetings[idx];
  }, []);

  const getDepName = (depName) => {
    if (depName === "All Departments") {
      return "All";
    } else {
      return depName?.toString();
    }
  };

  useEffect(() => {
    localStorage.setItem("tmpTriyoToken", getDepName(currDepartment?.name));
  }, [currDepartment]);

  return (
    <div className="dashboard-header-main">
      <div className="dashboard-header-main-inner">
        <div className="dashboard-header-text">
          <div className="head">My Dashboard | {formatDateWithDay(new Date())}</div>
          <div className="name">
            {randomGreeting}, <span>{user?.profile?.userNameFull.split(" ")[0]}</span>.
          </div>
        </div>

        <div className="dashboard-header-buttons">
          <FluentDropdownOptionAsObject
            value={currDepartment?.name}
            disabled={departments.length === 1}
            selectedOptions={[currDepartment?.name]}
            isControlled={true}
            options={departments?.map((department) => {
              return { name: department.name, id: department.companyID };
            })}
            onChange={(e, item) => {
              let dept = departments.find(
                (d) => d.companyID === item.optionValue
              );
              if (dept.name == "All") {
                dept.name = "All Departments";
              }
              setCurrDepartment(dept);
            }}
            label="Department"
            labelStyle="font-weight-normal"
          />

          {subDepartments.length > 0 &&
            currSubDepartment &&
            currSubDepartment.trim() !== "" && (
              <FluentDropdown
                value={currSubDepartment}
                disabled={subDepartments.length === 1}
                isControlled={true}
                options={subDepartments}
                selectedOptions={[currSubDepartment]}
                onChange={(e, item) => {
                  setSubCurrDepartment(item.optionValue);
                  localStorage.setItem("subdepartment", item.optionValue);
                }}
                label="Sub-department"
                labelStyle="font-weight-normal"
              />
            )}

          <DashboardButtonGroup
            currDepartment={currDepartment}
            fetchDepartmentData={fetchDepartmentData}
            refreshLoading={refreshLoading}
          />
        </div>
      </div>

      <div className="divider"></div>
    </div>
  );
};

export default DashboardHeader;

DashboardHeader.propTypes = {
  departments: PropTypes.array,
  currDepartment: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  setCurrDepartment: PropTypes.func,
  refreshLoading: PropTypes.bool,
  fetchDepartmentData: PropTypes.func,
  subDepartments: PropTypes.array,
  setSubCurrDepartment: PropTypes.func,
  currSubDepartment: PropTypes.string,
};